export const OrganizationTypes = {
  NON_COMMERCIAL: "NON_COMMERCIAL",
  COMMERCIAL: "COMMERCIAL",
  INTERNAL: "INTERNAL"
};
